"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var MomentProvider_1 = require("./MomentProvider");

var CachingMomentProvider =
/*#__PURE__*/
function (_MomentProvider_1$Mom) {
  _inherits(CachingMomentProvider, _MomentProvider_1$Mom);

  function CachingMomentProvider(cacheLimit, safeMode, info) {
    var _this;

    _classCallCheck(this, CachingMomentProvider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CachingMomentProvider).call(this));
    _this.cacheLimit = cacheLimit;
    _this.safeMode = safeMode;
    _this.info = info;
    _this.momentByTime = immutable_1.Map().asMutable();
    _this.momentByString = immutable_1.Map().asMutable();
    _this.provideCounter = 0;
    _this.cacheHitCounter = 0;
    return _this;
  }

  _createClass(CachingMomentProvider, [{
    key: "fromDate",
    value: function fromDate(date) {
      var _this2 = this;

      ++this.provideCounter;
      var time = date.getTime();
      var cachedValue = this.momentByTime.get(time);
      var output = this.getCachedOrCreate(cachedValue, function () {
        return _get(_getPrototypeOf(CachingMomentProvider.prototype), "fromDate", _this2).call(_this2, date);
      });
      this.updateCache(output.instance, time, output.instance.toISOString());
      return output;
    }
  }, {
    key: "fromString",
    value: function fromString(stringValue, pattern) {
      var _this3 = this;

      ++this.provideCounter;
      var cachedValue = this.momentByString.get(stringValue);
      var output = this.getCachedOrCreate(cachedValue, function () {
        return _get(_getPrototypeOf(CachingMomentProvider.prototype), "fromString", _this3).call(_this3, stringValue, pattern);
      });
      this.updateCache(output.instance, output.instance.valueOf(), stringValue);
      return output;
    }
  }, {
    key: "getCachedOrCreate",
    value: function getCachedOrCreate(cachedValue, createFun) {
      if (cachedValue) {
        ++this.cacheHitCounter;
        var instance = this.safeMode ? cachedValue.instance.clone() : cachedValue.instance;
        return {
          instance: instance,
          fromCache: true
        };
      } else {
        return createFun();
      }
    }
    /**
     * Moment provider caches only rounded moments (0 ms or 999ms).
     * It is much more likely that these moments can have cache hit.
     * @param instance moment to cache
     * @param time timestamp representation
     * @param stringValue string representation
     */

  }, {
    key: "updateCache",
    value: function updateCache(instance, time, stringValue) {
      var modulo = time % 1000;

      if (modulo === 0 || modulo === 999) {
        var cachedValue = {
          instance: instance,
          lastUsed: new Date().getTime()
        };
        this.momentByTime.set(time, cachedValue);
        this.momentByString.set(stringValue, cachedValue);
      }
    }
  }, {
    key: "clearObsolete",
    value: function clearObsolete() {
      this.clearObsoleteInCacheMap(this.momentByTime);
      this.clearObsoleteInCacheMap(this.momentByString);
    }
  }, {
    key: "clearObsoleteInCacheMap",
    value: function clearObsoleteInCacheMap(cacheMap) {
      if (cacheMap.size > this.cacheLimit) {
        var cacheList = cacheMap.entrySeq().toList();
        var sorted = cacheList.sort(function (a, b) {
          return a[1].lastUsed - b[1].lastUsed;
        });
        var toDelete = sorted.take(sorted.size - this.cacheLimit).map(function (item) {
          return item[0];
        });
        cacheMap.removeAll(toDelete);
      }
    }
    /**
     * Returns size of provider cache.
     */

  }, {
    key: "cacheSize",
    value: function cacheSize() {
      // size of both cache maps is the same
      return this.momentByTime.size;
    }
    /**
     * Returns cache hit rate in percent.
     */

  }, {
    key: "cacheHitRate",
    value: function cacheHitRate() {
      if (this.provideCounter === 0) {
        return 0;
      }

      return this.cacheHitCounter / this.provideCounter * 100;
    }
  }, {
    key: "startup",
    value: function startup() {
      var _this4 = this;

      this.info('CachingMomentProvider startup');

      _get(_getPrototypeOf(CachingMomentProvider.prototype), "startup", this).call(this);

      this.schedulerTimer = setInterval(function () {
        _this4.info("CachingMomentProvider statistics: cache contains ".concat(_this4.cacheSize(), " instances, ") + "provided ".concat(_this4.provideCounter, " instances with ").concat(_this4.cacheHitCounter, " cache hits, ") + "cache hit rate is ".concat(_this4.cacheHitRate().toFixed(2), "%"));

        _this4.clearObsolete();
      }, 60 * 1000 + Math.random() * 30 * 1000);
    }
  }, {
    key: "shutdown",
    value: function shutdown() {
      this.info('CachingMomentProvider shutdown');

      _get(_getPrototypeOf(CachingMomentProvider.prototype), "shutdown", this).call(this);

      if (this.schedulerTimer !== null) {
        // halt periodic execution of function
        clearInterval(this.schedulerTimer);
      }

      this.schedulerTimer = null; // clear caches

      this.momentByTime = immutable_1.Map().asMutable();
      this.momentByString = immutable_1.Map().asMutable();
    }
  }]);

  return CachingMomentProvider;
}(MomentProvider_1.MomentProvider);

exports.CachingMomentProvider = CachingMomentProvider;